import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import EmployeeForm from './pages/EmployeeForm';
import Home from './pages/Home';
import ServerSideTestTable from './pages/ServerSideTestTable';
import GlAccounts from './pages/GlAccounts';
import Vendor from './pages/Vendor';
import ReportsModule from './pages/ReportsModule';
import Assets from './pages/Assets';
import Po from './pages/Po';
import Item from './pages/Item';
import ItemLocation from './pages/ItemLocation';
import CashBookTrans from './pages/CashBookTrans';
import RequisitionInquiry from './pages/RequisitionInquiry';
import AssetAnalysisServerSide from './pages/AssetAnalysisServerSide';
import Admin from './pages/Admin';
import AbsenceManagement from './pages/AbsenceManagement';
import TrialBalance from './pages/TrialBalanceServerSide';
import InvoiceLookup from './pages/InvoiceLookup';
import CustomerActivity from './pages/CustomerActivity';
import AcTransServerSide from './pages/ActransServerSide';
import TransactionAnalysisServerSide from './pages/TransactionAnalysisServerSide';
import PoVendorInvoicePayment from './pages/PoVendorInvoicePayment';
import BillCost from './pages/BillCostAcParams';
import MetadataHelp from './pages/MetadataHelp';
import GlTransServerSideV2 from './pages/GlTransServerSideV2';
import ActransByActivityServerSide from './pages/ActransByActivityServerSide'
import JournalCotrol from './pages/JournalControl'
import PoInquiry from './pages/PoInquiry'
import PoReceipt from './pages/PoReceipt'
import CashPaymentInquiry from './pages/CashPaymentInquiry'
import AthenaReportBuilder from './pages/AthenaReportBuilder'
import UserAccount from './pages/UserAccount'
import InvoiceMatching from './pages/InvoiceMatching'
import TrialBalanceConsolidatedByCompanyGroup from './pages/TrialBalanceConsolidatedByCompanyGroup'
import Lp51 from './pages/Lp51';
import LengthOfService from './pages/LengthOfService';
import Garnishment from './pages/Garnishment';
import PayrollDistribution from './pages/PayrollDistribution';
import EmployeeAdvancedSearch from './pages/EmployeeAdvancedSearch';
import VendorAgreement from './pages/VendorAgreement';
import { 
  PERMISSIONS_REGISTRY, 
  isPageInRegistry,
  resolveEnabledModules,
  isModuleEnabled,
  getPageByKey
} from './config/permissions-registry';

const permissionedPages = [
  {
    path: '/absence-management',
    component: AbsenceManagement,
    module: 'HR'
  },
  {
    path: '/actrans',
    component: AcTransServerSide,
    module: 'ACTIVITY'
  },
  {
    path: '/actrans-activity',
    component: ActransByActivityServerSide,
    module: 'ACTIVITY'
  },
  {
    path: '/employee',
    component: EmployeeForm,
    module: 'HR'
  },
  {
    path: '/employee-advanced-search',
    component: EmployeeAdvancedSearch,
    module: 'HR'
  },
  {
    path: '/assets',
    component: Assets,
    module: 'ASSET'
  },
  {
    path: '/asset-analysis',
    component: AssetAnalysisServerSide,
    module: 'ASSET'
  },
  {
    path: '/transaction-analysis',
    component: TransactionAnalysisServerSide,
    module: 'ASSET'
  },
  {
    path: '/cash-book-trans',
    component: CashBookTrans,
    module: 'CASH'
  },
  // {
  //   path: '/serverside-test-table',
  //   component: ServerSideTestTable,
  //   module: null
  // },
  {
    path: '/reports',
    component: ReportsModule,
    module: null
  },
  {
    path: '/gl-accounts',
    component: GlAccounts,
    module: 'GL'
  },
  {
    path: '/gl-trans',
    component: GlTransServerSideV2,
    module: 'GL'
  },
  // {
  //   path: '/gl-trans-v2',
  //   component: GlTransServerSideV2,
  //   module: 'GL'
  // },
  // {
  //   path: '/gl-trans-no-select',
  //   component: GlTransServerSideNoSelect,
  //   module: 'GL'
  // },
  {
    path: '/item',
    component: Item,
    module: 'PO'
  },
  {
    path: '/item-loc',
    component: ItemLocation,
    module: 'PO'
  },
  {
    path: '/vendor',
    component: Vendor,
    module: 'AP'
  },
  {
    path: '/invoice-lookup',
    component: InvoiceLookup,
    module: 'AP'
  },
  {
    path: '/invoice-matching',
    component: InvoiceMatching,
    module: 'AP'
  },
  {
    path: '/po',
    component: Po,
    module: 'PO'
  },
  // {
  //   path: '/po-lookup',
  //   component: PoLookup,
  //   module: 'PO'
  // },
  {
    path: '/requisition-inquiry',
    component: RequisitionInquiry,
    module: 'PO'
  },
  {
    path: '/trial-balances',
    component: TrialBalance,
    module: 'GL'
  },
  {
    path: '/customer-activity',
    component: CustomerActivity,
    module: 'AR'
  },
  // {
  //   path: '/po-vendor',
  //   component: PoVendorInvoicePayment,
  //   module: 'PO'
  // },
  {
    path: '/bill-cost',
    component: BillCost,
    module: 'ACTIVITY'
  },
  {
    path: '/metadata',
    component: MetadataHelp,
    module: null
  },
  {
    path: '/journal-control',
    component: JournalCotrol,
    module: 'GL'
  },
  {
    path: '/po-inquiry',
    component: PoInquiry,
    module: 'PO'
  },
  {
    path: '/po-receipt',
    component: PoReceipt,
    module: 'PO'
  },
  {
    path: '/vendor-agreement',
    component: VendorAgreement,
    module: 'PO'
  },
  {
    path: '/trial-balances-consolidated',
    component: TrialBalanceConsolidatedByCompanyGroup,
    module: 'GL'
  },
  {
    path: '/cash-payment-inquiry',
    component: CashPaymentInquiry,
    module: 'CASH'
  },
  {
    path: '/athena-report-builder',
    component: AthenaReportBuilder,
    module: null
  },
  {
    path: '/account',
    component: UserAccount,
    module: null
  },
  {
    path: '/lp51',
    component: Lp51,
    module: 'HR'
  },
  {
    path: '/length-of-service',
    component: LengthOfService,
    module: 'HR'
  },
  {
    path: '/garnishment',
    component: Garnishment,
    module: 'HR'
  },
  {
    path: '/payroll-distribution',
    component: PayrollDistribution,
    module: 'HR'
  }
]

// Helper function to convert route path to page permission key
const pathToPageKey = (path) => {
  // Remove leading slash
  return path.replace(/^\//, '');
};

export default class Routes extends React.Component {
  render() {
    const auth = this.props;
    if (!auth.credentials) return null;

    const rawModules = auth?.credentials?.clientModules;
    const clientModules = resolveEnabledModules(rawModules);

    const pagePermission = auth.credentials.user.roleActions.page ?? {};

    const allow = auth?.credentials?.allow || (() => false)
    const allowPage = (subkey) => allow('page', subkey)

    return (
      <Switch>
        <Route
          exact
          path="/admin"
          render={
            (props) => {
              // SECURITY: Only allow if defined in registry
              if (!isPageInRegistry('admin')) {
                console.warn('Route "/admin" is not in permissions registry. Access denied.');
                return <Redirect to={{ pathname: '/' }} />;
              }
              
              return (pagePermission['admin']) ? (
                <Admin
                  {...props}
                  fetchInitialData={auth}
                  createSnack={auth.createSnack}
                />
              ) : (
                <Redirect
                  to={{
                    pathname: '/'
                  }}
                />
              );
            }
          }
        />
        {permissionedPages.map((p) => {
            const MyComponent = p.component;
            const pageKey = pathToPageKey(p.path);
            
            // SECURITY: Only allow routes that are defined in the permissions registry
            if (!isPageInRegistry(pageKey)) {
              console.warn(`Route "${p.path}" (key: "${pageKey}") is not in permissions registry. Access denied.`);
              return null; // Don't render route if not in registry
            }
            
            // Check if page's module is enabled for this client
            const pageInfo = getPageByKey(pageKey);
            const pageModule = pageInfo?.module;
            const isModuleEnabledForClient = !pageModule || isModuleEnabled(pageModule, clientModules);
            
            // Don't render route if module is not enabled
            if (!isModuleEnabledForClient) {
              return null;
            }
            
            const hasPermission = allowPage(pageKey);
            
            return (
              <Route
                key={p.path}
                exact
                path={p.path}
                render={(props) => 
                  hasPermission ? (
                    <MyComponent
                      {...props}
                      fetchInitialData={auth}
                      createSnack={auth.createSnack}
                    />
                  ) : (
                    <Redirect
                      to={{
                        pathname: '/'
                      }}
                    />
                  )
                }
              />
            );
          })}
        <Route
          path="/"
          render={(props) => (
            <Home
              {...props}
              fetchInitialData={auth}
              createSnack={auth.createSnack}
            />
          )}
        />
      </Switch>
    );
  }
}
